import CryptoJS from 'crypto-js';

export const encryptObject = (object, encryptionKey) => {
  const objectString = JSON.stringify(object);
  const encryptedString = CryptoJS.AES.encrypt(
    objectString,
    encryptionKey
  ).toString();
  return encryptedString;
};

export const decryptObject = (encryptedString, encryptionKey) => {
  const decryptedBytes = CryptoJS.AES.decrypt(encryptedString, encryptionKey);
  const decryptedString = decryptedBytes.toString(CryptoJS.enc.Utf8);
  const decryptedObject = JSON.parse(decryptedString);
  return decryptedObject;
};
